import { Directive, input } from '@angular/core';
import { ConditionalFn, CustomValidationService } from '../services/custom-validation.service';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[appConditionalValidator]',
  providers: [{
    provide: NG_VALIDATORS, useExisting: ConditionalValidatorDirective, multi: true
  }]
})
export class ConditionalValidatorDirective implements Validator {
  appConditionalValidator = input.required<ValidatorFn>();
  condition = input.required<ConditionalFn>();

  validate(control: AbstractControl<any, any>): ValidationErrors {
    return CustomValidationService.conditionalValidator(this.condition(), this.appConditionalValidator() ?? [])(control);
  }
}
